import { IMessageTree, IChat, Role } from '../api/llmapi';
import { Message } from './message';

export class Chat {
    id          : string;
    name        : string;
    description : string;
    rootMessage : Message;

    constructor(root : Message)
    {
        this.id          = "";
        this.name        = "Default Description";
        this.description = "";
        this.rootMessage = root;
    }

    addReply(msg : Message) : void
    {
        let last = this.rootMessage;
        while(true) {
            let next = last.getReply();
            if (next === undefined) {
                break;
            }
            last = next;
        }

        last.addReply(msg);
    }

    getMessages() : Message[]
    {
        let messages : Message[] = [];

        let msg : Message | undefined = this.rootMessage;
        while(msg !== undefined) {
            messages.push(msg);
            msg = msg.getReply();
        }
        return messages;
    }

    getSystemPrompt() : string
    {
        if (this.rootMessage.role === Role.System) {
            return this.rootMessage.content;
        }
        else {
            return "";
        }
    }

    getTree() : IMessageTree
    {
        return this.rootMessage!.toJson();
    }

    static load(src : IChat) : Chat
    {
        let chat : Chat = new Chat(Message.load(src.tree));

        chat.name        = src.name;
        chat.description = src.description;
        chat.id          = src.id;

        return chat;
    }

    isNew() : boolean
    {
        return this.id === "";
    }

    setSystemPrompt(prompt : string) : void
    {
        if (this.rootMessage.role === Role.System) {
            this.rootMessage.content   = prompt;
            this.rootMessage.timestamp = new Date();
        }
        else {
            const old = this.rootMessage;
            this.rootMessage = new Message(Role.System, prompt);
            this.rootMessage.addReply(old);
        }
    }
};

